import React, { useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import './deleteConfirmationModal.scss';
import CustomButton from '../Button/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onDelete, message }) => {
  const defaultMessage = 'Are you sure you want to delete this item? This action cannot be undone.';

  useEffect(() => {
    const handleOverlayClick = (event) => {
      if (event.target.classList.contains('delete-modal-overlay')) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('click', handleOverlayClick);
    }

    return () => {
      document.removeEventListener('click', handleOverlayClick);
    };
  }, [isOpen, onClose]);

  return isOpen && (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <div className="modal-header">
          <DeleteIcon className="warning-icon"/>
          <h3 id='delete-modal-heading'>Confirm Delete</h3>
        </div>
        <p dangerouslySetInnerHTML={{ __html: message || defaultMessage }}></p>
        <div className="modal-actions">
          <CustomButton onClick={onClose} btnLabel="Cancel" className="cancel-button" autoFocus />
          <CustomButton
            buttonType="delete"
            onClick={onDelete}
            btnLabel="Delete"
            className="delete-button"
          />
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
